// @flow
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import rootReducer from './reducers';
import initialStore from './initialStore';
import { isProduction } from '../utils/utils';

export const initStore = (isServer) => {
  if (isServer && typeof window === 'undefined') {
    return createStore(
      rootReducer,
      initialStore,
      applyMiddleware(thunk, logger)
    );
  }
  if (!window.store) {
    if (isProduction) {
      window.store = applyMiddleware(thunk)(createStore)(rootReducer, initialStore); // no redux logger in production
    } else {
      const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
      window.store = composeEnhancers(applyMiddleware(thunk, logger))(createStore)(rootReducer, initialStore);
    }
  }
  return window.store;
};

export default initStore();



// WEBPACK FOOTER //
// ./src/store/index.js